import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type NotesAccessorFn<T> = TypedAccessor<T, string | undefined>
type NotesColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width">
export type NotesColumnHelper<T> = (
  accessorFn: NotesAccessorFn<T>,
  col: NotesColumn<T>
) => DataColumn<T>

export function notes<T>(
  accessorFn: NotesAccessorFn<T>,
  col: NotesColumn<T>
): DataColumn<T> {
  return data({
    renderCell: accessorFn,
    width: TableCellWidth.ExtraLarge,
    ...col,
  })
}
